import { Component, Input, OnInit } from '@angular/core';

interface AmortizationSchedule {
  idX1: number;
  instalmentAmountX1: number;
  instalmentDueDateX1: string;
  instalmentNumberX1: number;
  instalmentPaidX1: number;
  instalmentPaymentDateX1: string;
  instalmentPaymentTimeX1: string;
  instalmentRemainingX1: number;
  instalmentStatusX1: number
  interestAmountX1: number;
  interestPaidX1: number;
  interestRemainingX1: number;
  interestReversedX1: number;
  interestWrittenOffX1: number;
  penaltyAmountX1: number;
  penaltyPaidX1: number;
  penaltyRemainingX1: number;
  principalAmountX1: number;
  principalPaidX1: number;
  principalRemainingX1: number;
  principalReversedX1: number;
  principalWrittenOffX1: number;
}
export interface MicroLoanCustomer {
  customerPhotoUrl: string;
  customerId: number;
  customerName: string;
  customerPhone1: string;
}
@Component({
  selector: 'app-amortization-schedule',
  templateUrl: './amortization-schedule.component.html',
  styleUrls: ['./amortization-schedule.component.scss']
})
export class AmortizationScheduleComponent implements OnInit {

  constructor() { }
  @Input() itm: AmortizationSchedule;
  @Input() customer: MicroLoanCustomer;
  ngOnInit(): void {
  }

}
